import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-183afec9")

_pushScopeId("data-v-183afec9")
const _hoisted_1 = {
  "separator-class": "el-icon-arrow-right",
  style: {"display":"flex","align-items":"center","justify-content":"space-between","width":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { style: {"font-size":"14px","color":"#606266"} }, [
  /*#__PURE__*/_createVNode("span", null, "自动化任务"),
  /*#__PURE__*/_createVNode("i", { class: "el-breadcrumb__separator el-icon-arrow-right" }),
  /*#__PURE__*/_createVNode("span", null, "测试任务")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("复制任务")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新建任务")
const _hoisted_5 = { class: "dialogTitle" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "新增场景", -1)
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确 认")
const _hoisted_10 = { class: "dialogTitle" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "版本", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_13 = { class: "dialog-footer" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("确 认")
const _hoisted_16 = { class: "dialogTitle" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "版本", -1)
const _hoisted_18 = { class: "dialog-footer" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("确 认")
const _hoisted_21 = { class: "dialog-footer" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_24 = { class: "task" }
const _hoisted_25 = {
  key: 0,
  class: "testForm"
}
const _hoisted_26 = { style: {"text-align":"center"} }
const _hoisted_27 = {
  key: 0,
  style: {"color":"#aaaaaa"}
}
const _hoisted_28 = {
  key: 1,
  style: {"color":"#cc0000"}
}
const _hoisted_29 = {
  key: 2,
  style: {"color":"mediumseagreen"}
}
const _hoisted_30 = {
  key: 3,
  style: {"color":"{#F00}"}
}
const _hoisted_31 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 3,
  style: {"width":"36px"}
}
const _hoisted_34 = {
  key: 4,
  class: "el-icon-link"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("span", null, "历史执行次数", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-info",
  style: {"color":"#ffa000"}
}, null, -1)
const _hoisted_37 = { style: {"color":"mediumseagreen"} }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", null, "/", -1)
const _hoisted_39 = { style: {"color":"#cc0000"} }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("暂停")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("继续")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("启动")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("配置")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_47 = { class: "d-flex" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("批量导入场景")
const _hoisted_49 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("span", null, "基础设置", -1)
const _hoisted_51 = { style: {"text-align":"center"} }
const _hoisted_52 = { class: "box-card-task2" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("添加场景")
const _hoisted_54 = { class: "card-header-form" }
const _hoisted_55 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-info",
  size: "small"
}, null, -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("span", null, "  ", -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode("COPY")
const _hoisted_58 = /*#__PURE__*/_createVNode("span", null, "  ", -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("i", { class: "el-icon-delete-solid" }, null, -1)
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "labelStyle2" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("多选")
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { style: {"width":"159px"} }, [
  /*#__PURE__*/_createVNode("label", null, "设备")
], -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { style: {"width":"100px"} }, [
  /*#__PURE__*/_createVNode("label", null, "场景脚本")
], -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("div", { style: {"width":"100px"} }, [
  /*#__PURE__*/_createVNode("label", null, "游戏英雄")
], -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { style: {"width":"100px"} }, [
  /*#__PURE__*/_createVNode("label", null, "游戏皮肤")
], -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { style: {"width":"100px"} }, [
  /*#__PURE__*/_createVNode("label", null, "等待时长(s)")
], -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("div", { style: {"width":"100px"} }, [
  /*#__PURE__*/_createVNode("label", null, "登陆账号")
], -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { style: {"width":"50px"} }, null, -1)
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { class: "labelStyle2" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode("多选")
const _hoisted_73 = /*#__PURE__*/_createVNode("div", { style: {"width":"159px"} }, [
  /*#__PURE__*/_createVNode("label", null, "设备")
], -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("div", { style: {"width":"100px"} }, [
  /*#__PURE__*/_createVNode("label", null, "场景脚本")
], -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { style: {"width":"100px"} }, [
  /*#__PURE__*/_createVNode("label", null, "等待时长(s)")
], -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("div", { style: {"width":"100px"} }, [
  /*#__PURE__*/_createVNode("label", null, "登陆账号")
], -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { style: {"width":"126px"} }, null, -1)
const _hoisted_78 = { key: 2 }
const _hoisted_79 = { class: "labelStyle2" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode("多选")
const _hoisted_81 = /*#__PURE__*/_createVNode("div", { style: {"width":"159px"} }, [
  /*#__PURE__*/_createVNode("label", null, "设备")
], -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { style: {"width":"100px"} }, [
  /*#__PURE__*/_createVNode("label", null, "场景脚本")
], -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("div", { style: {"width":"100px"} }, [
  /*#__PURE__*/_createVNode("label", null, "等待时长(s)")
], -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("div", { style: {"width":"100px"} }, [
  /*#__PURE__*/_createVNode("label", null, "登陆账号")
], -1)
const _hoisted_85 = { style: {"width":"100px"} }
const _hoisted_86 = /*#__PURE__*/_createVNode("label", null, "受邀账号", -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { style: {"width":"50px"} }, null, -1)
const _hoisted_89 = /*#__PURE__*/_createVNode("i", { class: "el-icon-warning warningIcon" }, null, -1)
const _hoisted_90 = { class: "addForm" }
const _hoisted_91 = { style: {"float":"left"} }
const _hoisted_92 = {
  key: 0,
  class: "gray-icon"
}
const _hoisted_93 = {
  key: 1,
  class: "goldenrod-icon"
}
const _hoisted_94 = {
  key: 2,
  class: "mediumseagreen-icon"
}
const _hoisted_95 = /*#__PURE__*/_createTextVNode("自定义配置 ")
const _hoisted_96 = /*#__PURE__*/_createVNode("i", { class: "el-icon-delete-solid" }, null, -1)
const _hoisted_97 = { style: {"text-align":"left"} }
const _hoisted_98 = /*#__PURE__*/_createTextVNode("添加设备")
const _hoisted_99 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_100 = /*#__PURE__*/_createTextVNode(" 高级设置 ")
const _hoisted_101 = { style: {"width":"1000px","margin":"auto"} }
const _hoisted_102 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_103 = { style: {"text-align":"left"} }
const _hoisted_104 = /*#__PURE__*/_createTextVNode("自定义配置")
const _hoisted_105 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_106 = /*#__PURE__*/_createTextVNode(" 报告设置 ")
const _hoisted_107 = { style: {"width":"1000px","margin":"auto"} }
const _hoisted_108 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("报告显示设置")
], -1)
const _hoisted_109 = /*#__PURE__*/_createTextVNode(" 核心指标 ")
const _hoisted_110 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_111 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_112 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" 核心场景 ")
const _hoisted_114 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_115 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_116 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_117 = /*#__PURE__*/_createTextVNode(" 趋势指标 ")
const _hoisted_118 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_119 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_120 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_121 = /*#__PURE__*/_createTextVNode(" 趋势场景 ")
const _hoisted_122 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_123 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_124 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_125 = /*#__PURE__*/_createTextVNode(" 屏蔽场景 ")
const _hoisted_126 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_127 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_128 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_129 = /*#__PURE__*/_createTextVNode(" 屏蔽设备 ")
const _hoisted_130 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_131 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_132 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_133 = { style: {"flex-direction":"column"} }
const _hoisted_134 = /*#__PURE__*/_createTextVNode(" 详细指标 ")
const _hoisted_135 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_136 = /*#__PURE__*/_createVNode("li", null, "基础：", -1)
const _hoisted_137 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_138 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_139 = /*#__PURE__*/_createVNode("li", null, "深度：", -1)
const _hoisted_140 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_141 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_142 = /*#__PURE__*/_createVNode("li", null, "定制：", -1)
const _hoisted_143 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_144 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_145 = /*#__PURE__*/_createVNode("li", { style: {"width":"173px"} }, "允许任务数据部分缺失", -1)
const _hoisted_146 = /*#__PURE__*/_createVNode("li", { style: {"width":"173px"} }, "数据详情模块", -1)
const _hoisted_147 = /*#__PURE__*/_createTextVNode("展示对比数据 ")
const _hoisted_148 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_149 = /*#__PURE__*/_createTextVNode("报告通知设置 ")
const _hoisted_150 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_151 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_152 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_153 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_154 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_155 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_156 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_157 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_158 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_159 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_160 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_161 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_162 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_163 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_164 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_165 = { style: {"text-align":"end","padding":"20px 36px"} }
const _hoisted_166 = { key: 0 }
const _hoisted_167 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_168 = { class: "dialog-footer" }
const _hoisted_169 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_170 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_171 = { class: "dialog-footer" }
const _hoisted_172 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_173 = /*#__PURE__*/_createTextVNode("保存")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")
  const _component_el_descriptions = _resolveComponent("el-descriptions")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_space = _resolveComponent("el-space")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_el_time_picker = _resolveComponent("el-time-picker")
  const _component_el_time_select = _resolveComponent("el-time-select")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _component_el_drawer = _resolveComponent("el-drawer")
  const _component_el_footer = _resolveComponent("el-footer")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _hoisted_2,
                _createVNode("div", null, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyData((_ctx.dialogVisibleRunmax = true)))),
                    disabled: _ctx.get_is_super,
                    type: "primary",
                    size: "small"
                  }, {
                    default: _withId(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleCreateForm(_ctx.ruleForm))),
                    disabled: _ctx.get_is_super,
                    type: "primary",
                    size: "small"
                  }, {
                    default: _withId(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _createVNode(_component_el_dialog, {
                width: "615px",
                onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addScript = false)),
                modelValue: _ctx.addScript,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.addScript = $event))
              }, {
                title: _withId(() => [
                  _createVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_el_divider)
                  ])
                ]),
                footer: _withId(() => [
                  _createVNode("span", _hoisted_7, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addScript = false)),
                      type: "info"
                    }, {
                      default: _withId(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      onClick: _ctx.addAddScript
                    }, {
                      default: _withId(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    "label-position": "top",
                    size: "small"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        label: "版本名称",
                        size: "small",
                        prop: "original_scene_id",
                        style: {"width":"40%"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            placeholder: "请输入版本名称",
                            modelValue: _ctx.addVersion,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.addVersion = $event)),
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_dialog, {
                width: "615px",
                onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dialogAddFormVisible = false)),
                modelValue: _ctx.dialogAddFormVisible,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogAddFormVisible = $event))
              }, {
                title: _withId(() => [
                  _createVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_el_divider)
                  ])
                ]),
                footer: _withId(() => [
                  _createVNode("span", _hoisted_13, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogAddFormVisible = false)),
                      type: "info"
                    }, {
                      default: _withId(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitAddForm()))
                    }, {
                      default: _withId(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    "label-position": "top",
                    ref: "ruleaddForm",
                    size: "small"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        label: "版本",
                        prop: "script_scene",
                        style: {"width":"360px"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.filterVersions,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterVersions = $event)),
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择版本"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsList, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.version,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_button, {
                            onClick: _ctx.openAddScript,
                            style: {"color":"#c0c4cc"}
                          }, {
                            default: _withId(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_dialog, {
                width: "615px",
                onClose: _ctx.closeDialogVersion,
                modelValue: _ctx.dialogAddVersionVisible,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialogAddVersionVisible = $event))
              }, {
                title: _withId(() => [
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_el_divider)
                  ])
                ]),
                footer: _withId(() => [
                  _createVNode("span", _hoisted_18, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _ctx.closeDialogVersion,
                      type: "info"
                    }, {
                      default: _withId(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      onClick: _ctx.submitVersion
                    }, {
                      default: _withId(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    "label-position": "top",
                    ref: "ruleaddForm",
                    size: "small"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.taskVersion,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.taskVersion = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              }, 8, ["onClose", "modelValue"]),
              _createVNode(_component_el_dialog, {
                modelValue: _ctx.dialogVisibleRunmax,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialogVisibleRunmax = $event)),
                width: "30%",
                onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialogVisibleRunmax = false))
              }, {
                footer: _withId(() => [
                  _createVNode("span", _hoisted_21, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.dialogVisibleRunmax = false))
                    }, {
                      default: _withId(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.UploadRunmax()))
                    }, {
                      default: _withId(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    model: _ctx.copyForm,
                    size: "small"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "复制次数" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            style: {"width":"150px"},
                            modelValue: _ctx.copyForm.count,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.copyForm.count = $event)),
                            placeholder: "请输入"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "task_id" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            style: {"width":"150px"},
                            modelValue: _ctx.copyForm.task_id,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.copyForm.task_id = $event)),
                            placeholder: "请输入"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_divider),
              _withDirectives(_createVNode("div", _hoisted_24, [
                _createVNode(_component_el_card, { class: "spacName tableMinH" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_table, {
                      size: "mini",
                      data: _ctx.getTasks(_ctx.search),
                      "header-cell-class-name": "tabelHeader"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, { type: "expand" }, {
                          default: _withId((props) => [
                            (props.row.task_configuration.length !== 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_25, [
                                  _createVNode(_component_el_table, {
                                    "header-cell-class-name": "tabelHeader",
                                    "span-method": _ctx.taskGroupSpanMethod,
                                    data: props.row.task_configuration
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_table_column, {
                                        prop: "scene",
                                        label: "场景"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "script",
                                        label: "脚本"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "device_model",
                                        label: "设备型号"
                                      }, {
                                        default: _withId((scope) => [
                                          _createVNode(_component_el_popover, {
                                            effect: "light",
                                            trigger: "hover",
                                            placement: "top",
                                            width: 250
                                          }, {
                                            default: _withId(() => [
                                              _createVNode("p", _hoisted_26, _toDisplayString(scope.row.device_model +
                                  " - " +
                                  (scope.row.device_level + 1) +
                                  "档机"), 1)
                                            ]),
                                            reference: _withId(() => [
                                              _createVNode("div", null, [
                                                _createVNode(_component_el_tag, { size: "medium" }, {
                                                  default: _withId(() => [
                                                    _createTextVNode(_toDisplayString(scope.row.note +
                                    " - " +
                                    scope.row.device_name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "device_status",
                                        label: "状态"
                                      }, {
                                        default: _withId((scope) => [
                                          (scope.row.device_status === '离线')
                                            ? (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(scope.row.device_status), 1))
                                            : (scope.row.device_status === '占用')
                                              ? (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(scope.row.device_status), 1))
                                              : (scope.row.device_status === '空闲')
                                                ? (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(scope.row.device_status), 1))
                                                : (_openBlock(), _createBlock("span", _hoisted_30, _toDisplayString(scope.row.device_status), 1))
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "account",
                                        label: "账号"
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["span-method", "data"]),
                                  _hoisted_31,
                                  (props.row.is_expand_settings)
                                    ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_descriptions, { title: "高级设置" }, {
                                            default: _withId(() => [
                                              (
                            props.row.task_content_json.global_settings
                              .downloader.pipeline !== ''
                          )
                                                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                                    key: 0,
                                                    label: "安装包自动下载："
                                                  }, {
                                                    default: _withId(() => [
                                                      _createTextVNode(" 流水线：" + _toDisplayString(props.row.downloader_pipeline) + " ", 1),
                                                      _createVNode("span", null, "  构建号：" + _toDisplayString(props.row.task_content_json.global_settings
                                .downloader?.build_id || "-"), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true),
                                              (
                            props.row.task_content_json.global_settings.trigger
                              .type
                          )
                                                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                                                    key: 1,
                                                    label: "定时任务配置："
                                                  }, {
                                                    default: _withId(() => [
                                                      _createTextVNode(_toDisplayString(props.row.global_settings_trigger_time), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_32, [
                                  _createVNode(_component_el_empty, {
                                    "image-size": 50,
                                    description: "No Data"
                                  })
                                ]))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "任务名称" }, {
                          default: _withId((scope) => [
                            _createVNode(_component_el_tooltip, {
                              effect: "dark",
                              placement: "top"
                            }, {
                              content: _withId(() => [
                                _createVNode("span", null, _toDisplayString(scope.row.task_id), 1)
                              ]),
                              default: _withId(() => [
                                _createVNode("span", null, _toDisplayString(scope.row.task_name), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "当前状态" }, {
                          default: _withId((scope) => [
                            _createVNode(_component_el_space, null, {
                              default: _withId(() => [
                                (
                        scope.row.status === '取消' ||
                        scope.row.status === '异常'
                      )
                                  ? (_openBlock(), _createBlock(_component_el_link, {
                                      key: 0,
                                      type: "danger",
                                      style: {"font-size":"1em","width":"36px"},
                                      href: '/taskDetails?id=' + scope.row.task_record_id
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(scope.row.status), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["href"]))
                                  : (scope.row.status === '完成')
                                    ? (_openBlock(), _createBlock(_component_el_link, {
                                        key: 1,
                                        type: "success",
                                        style: {"font-size":"1em","width":"36px"},
                                        href: '/taskDetails?id=' + scope.row.task_record_id
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(scope.row.status), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["href"]))
                                    : (
                        scope.row.status === '进行中' ||
                        scope.row.status === '暂停'
                      )
                                      ? (_openBlock(), _createBlock(_component_el_link, {
                                          key: 2,
                                          type: "warning",
                                          style: {"font-size":"1em","width":"36px"},
                                          href: '/taskDetails?id=' + scope.row.task_record_id
                                        }, {
                                          default: _withId(() => [
                                            _createTextVNode(_toDisplayString(scope.row.status), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["href"]))
                                      : (_openBlock(), _createBlock("span", _hoisted_33, _toDisplayString(scope.row.status), 1)),
                                (scope.row.status !== '-')
                                  ? (_openBlock(), _createBlock("i", _hoisted_34))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "最近更新时间",
                          prop: "update_date"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "最近更新者",
                          prop: "update_user"
                        }),
                        _createVNode(_component_el_table_column, { label: "上次执行时间" }, {
                          default: _withId((scope) => [
                            _createVNode("span", null, _toDisplayString(scope.row.start_date), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "历史执行次数" }, {
                          header: _withId(() => [
                            _createVNode(_component_el_space, null, {
                              default: _withId(() => [
                                _hoisted_35,
                                _createVNode(_component_el_tooltip, {
                                  class: "item",
                                  effect: "dark",
                                  content: "已完成 / 取消,异常",
                                  placement: "right"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_36
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withId((scope) => [
                            _createVNode("span", _hoisted_37, _toDisplayString(scope.row.complete_number), 1),
                            _hoisted_38,
                            _createVNode("span", _hoisted_39, _toDisplayString(scope.row.abnormal_number), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "right",
                          width: "300px;"
                        }, {
                          header: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.search1,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.search1 = $event)),
                              size: "mini",
                              placeholder: "输入关键字搜索",
                              onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onSearch('Search')))
                            }, null, 8, ["modelValue"])
                          ]),
                          default: _withId((scope) => [
                            _createVNode(_component_el_space, { wrap: "" }, {
                              default: _withId(() => [
                                (scope.row.status === '进行中')
                                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                                      key: 0,
                                      onConfirm: ($event: any) => (_ctx.handleRun(scope.row, 1)),
                                      title: "是否暂停任务？"
                                    }, {
                                      reference: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          size: "mini",
                                          type: "warning"
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_40
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onConfirm"]))
                                  : (scope.row.status === '暂停')
                                    ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                                        key: 1,
                                        onConfirm: ($event: any) => (_ctx.handleRun(scope.row, 2)),
                                        title: "是否继续进行任务？"
                                      }, {
                                        reference: _withId(() => [
                                          _createVNode(_component_el_button, { size: "mini" }, {
                                            default: _withId(() => [
                                              _hoisted_41
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onConfirm"]))
                                    : (scope.row.status === '异常')
                                      ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                                          key: 2,
                                          onConfirm: ($event: any) => (_ctx.handleRun(scope.row, 3)),
                                          title: "是否取消执行任务？"
                                        }, {
                                          reference: _withId(() => [
                                            _createVNode(_component_el_button, {
                                              size: "mini",
                                              type: "danger"
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_42
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onConfirm"]))
                                      : (_openBlock(), _createBlock(_component_el_button, {
                                          key: 3,
                                          onClick: ($event: any) => (_ctx.handleRun(scope.row, 0)),
                                          size: "mini",
                                          type: "success",
                                          disabled: _ctx.get_is_super
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_43
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick", "disabled"])),
                                (
                        scope.row.status === '进行中' ||
                        scope.row.status === '暂停'
                      )
                                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                                      key: 4,
                                      onConfirm: ($event: any) => (_ctx.handleRun(scope.row, 3)),
                                      title: "是否取消执行任务？"
                                    }, {
                                      reference: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          size: "mini",
                                          type: "danger"
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_44
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onConfirm"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: "primary",
                                  onClick: ($event: any) => (_ctx.handleEdit(_ctx.ruleForm, scope.row)),
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withId(() => [
                                    _hoisted_45
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "disabled"]),
                                _createVNode(_component_el_popconfirm, {
                                  confirmButtonType: "text",
                                  cancelButtonType: "primary",
                                  onConfirm: ($event: any) => (_ctx.handleDeleteTask(scope.$index, scope.row)),
                                  title: "确定删除任务？"
                                }, {
                                  reference: _withId(() => [
                                    _createVNode(_component_el_button, {
                                      size: "mini",
                                      type: "danger",
                                      disabled: _ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_46
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 2
                                }, 1032, ["onConfirm"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                })
              ], 512), [
                [_directive_loading, _ctx.loading]
              ]),
              _createVNode(_component_el_drawer, {
                title: _ctx.handleFormTitle,
                modelValue: _ctx.formTask,
                "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => (_ctx.formTask = $event)),
                direction: "rtl",
                onClosed: _cache[105] || (_cache[105] = ($event: any) => (_ctx.closed(_ctx.ruleForm))),
                "destroy-on-close": "",
                size: "60%"
              }, {
                default: _withId(() => [
                  _withDirectives(_createVNode(_component_el_form, {
                    model: _ctx.ruleForm,
                    rules: _ctx.rules,
                    ref: "ruleForm",
                    "label-width": "100px"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_space, { size: 75 }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, {
                            label: "任务名称",
                            size: "mini",
                            prop: "task_name"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_47, [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.ruleForm.task_name,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.ruleForm.task_name = $event)),
                                  style: {"width":"300px"},
                                  class: "me-2"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_el_upload, {
                                  ref: "uploadRef",
                                  class: "display: inline-block",
                                  "auto-upload": false,
                                  action: "/",
                                  accept: ".xlsx",
                                  "show-file-list": false,
                                  "on-change": _ctx.onMultiImport
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_button, { type: "primary" }, {
                                      default: _withId(() => [
                                        _hoisted_48
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["on-change"])
                              ])
                            ]),
                            _: 1
                          }),
                          (_ctx.get_is_semi())
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                label: "任务项目",
                                size: "mini",
                                prop: "sub_project"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    size: "mini",
                                    modelValue: _ctx.ruleForm.sub_project,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.ruleForm.sub_project = $event)),
                                    placeholder: "默认当前项目",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_projects(), (project) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: project.id,
                                          label: project.project_name,
                                          value: project.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { type: "flex" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_collapse, {
                            modelValue: _ctx.active_collapases,
                            "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => (_ctx.active_collapases = $event)),
                            style: {"width":"1500px"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_collapse_item, { name: "1" }, {
                                title: _withId(() => [
                                  _createVNode(_component_el_space, { size: 15 }, {
                                    default: _withId(() => [
                                      _hoisted_49,
                                      _hoisted_50
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_51, [
                                    _createVNode("div", _hoisted_52, [
                                      _createVNode(_component_el_button, {
                                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.addTask(_ctx.ruleForm.global_settings_task_group))),
                                        type: "primary",
                                        size: "mini"
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_53
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createVNode(_component_el_space, {
                                      style: {"overflow":"auto","max-height":"800px","box-sizing":"border-box","padding":"0px 8px"},
                                      size: 10,
                                      direction: "vertical"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ruleForm.global_settings_task_group.slice(
                          (_ctx.ruleform_page - 1) * _ctx.ruleform_size,
                          _ctx.ruleform_page * _ctx.ruleform_size
                        ), (task, index) => {
                                          return (_openBlock(), _createBlock(_component_el_card, {
                                            id: "allLength",
                                            class: "box-card-task",
                                            key: task.key,
                                            index: index,
                                            style: {"position":"relative"}
                                          }, {
                                            header: _withId(() => [
                                              _createVNode("div", _hoisted_54, [
                                                _createVNode("span", null, [
                                                  _createVNode(_component_el_tooltip, {
                                                    effect: "dark",
                                                    content: "同个场景可配多台设备，多台设备测试任务同时执行",
                                                    placement: "bottom"
                                                  }, {
                                                    default: _withId(() => [
                                                      _hoisted_55
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createTextVNode(" 场景" + _toDisplayString((_ctx.ruleform_page - 1) * _ctx.ruleform_size + index + 1) + " ", 1),
                                                  _hoisted_56,
                                                  _createVNode(_component_el_select, {
                                                    size: "mini",
                                                    modelValue: task.scene_id,
                                                    "onUpdate:modelValue": ($event: any) => (task.scene_id = $event),
                                                    placeholder: "选择场景",
                                                    filterable: "",
                                                    onChange: ($event: any) => (_ctx.sceneChange(task))
                                                  }, {
                                                    default: _withId(() => [
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getProjectScenes, (project_scene) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: project_scene.id,
                                                          label: project_scene.chinese,
                                                          value: project_scene.id
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                                ]),
                                                _createVNode("div", null, [
                                                  _createVNode(_component_el_button, {
                                                    type: "info",
                                                    size: "mini",
                                                    onClick: ($event: any) => (
                                  _ctx.copyTask1(
                                    task,
                                    _ctx.ruleForm.global_settings_task_group
                                  )
                                )
                                                  }, {
                                                    default: _withId(() => [
                                                      _hoisted_57
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]),
                                                  _hoisted_58,
                                                  _createVNode(_component_el_button, {
                                                    type: "danger",
                                                    size: "mini",
                                                    onClick: _withModifiers(($event: any) => (
                                  _ctx.removeTask(
                                    task,
                                    _ctx.ruleForm.global_settings_task_group
                                  )
                                ), ["prevent"])
                                                  }, {
                                                    default: _withId(() => [
                                                      _hoisted_59
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ])
                                              ])
                                            ]),
                                            default: _withId(() => [
                                              (!_ctx.projectIsInvitee && _ctx.projectIsKing)
                                                ? (_openBlock(), _createBlock("div", _hoisted_60, [
                                                    _createVNode(_component_el_space, { direction: "labelStyle" }, {
                                                      default: _withId(() => [
                                                        _createVNode("div", _hoisted_61, [
                                                          _createVNode("label", null, [
                                                            _createVNode(_component_el_checkbox, {
                                                              onChange: ($event: any) => (
                                    _ctx.getDeviceChecked(
                                      _ctx.ruleForm.global_settings_task_group,
                                      (_ctx.ruleform_page - 1) * _ctx.ruleform_size +
                                        index
                                    )
                                  ),
                                                              modelValue: 
                                    _ctx.DeviceChecked[
                                      (_ctx.ruleform_page - 1) * _ctx.ruleform_size +
                                        index
                                    ]
                                  ,
                                                              "onUpdate:modelValue": ($event: any) => (
                                    _ctx.DeviceChecked[
                                      (_ctx.ruleform_page - 1) * _ctx.ruleform_size +
                                        index
                                    ]
                                   = $event)
                                                            }, {
                                                              default: _withId(() => [
                                                                _hoisted_62
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                                                          ])
                                                        ]),
                                                        _hoisted_63,
                                                        _hoisted_64,
                                                        _hoisted_65,
                                                        _hoisted_66,
                                                        _hoisted_67,
                                                        _hoisted_68,
                                                        _hoisted_69
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]))
                                                : (!_ctx.projectIsInvitee && !_ctx.projectIsKing)
                                                  ? (_openBlock(), _createBlock("div", _hoisted_70, [
                                                      _createVNode(_component_el_space, { direction: "labelStyle" }, {
                                                        default: _withId(() => [
                                                          _createVNode("div", _hoisted_71, [
                                                            _createVNode("label", null, [
                                                              _createVNode(_component_el_checkbox, {
                                                                onChange: ($event: any) => (
                                    _ctx.getDeviceChecked(
                                      _ctx.ruleForm.global_settings_task_group,
                                      (_ctx.ruleform_page - 1) * _ctx.ruleform_size +
                                        index
                                    )
                                  ),
                                                                modelValue: 
                                    _ctx.DeviceChecked[
                                      (_ctx.ruleform_page - 1) * _ctx.ruleform_size +
                                        index
                                    ]
                                  ,
                                                                "onUpdate:modelValue": ($event: any) => (
                                    _ctx.DeviceChecked[
                                      (_ctx.ruleform_page - 1) * _ctx.ruleform_size +
                                        index
                                    ]
                                   = $event)
                                                              }, {
                                                                default: _withId(() => [
                                                                  _hoisted_72
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                                                            ])
                                                          ]),
                                                          _hoisted_73,
                                                          _hoisted_74,
                                                          _hoisted_75,
                                                          _hoisted_76,
                                                          _hoisted_77
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]))
                                                  : (_ctx.projectIsInvitee && !_ctx.projectIsKing)
                                                    ? (_openBlock(), _createBlock("div", _hoisted_78, [
                                                        _createVNode(_component_el_space, { direction: "labelStyle" }, {
                                                          default: _withId(() => [
                                                            _createVNode("div", _hoisted_79, [
                                                              _createVNode("label", null, [
                                                                _createVNode(_component_el_checkbox, {
                                                                  onChange: ($event: any) => (
                                    _ctx.getDeviceChecked(
                                      _ctx.ruleForm.global_settings_task_group,
                                      (_ctx.ruleform_page - 1) * _ctx.ruleform_size +
                                        index
                                    )
                                  ),
                                                                  modelValue: 
                                    _ctx.DeviceChecked[
                                      (_ctx.ruleform_page - 1) * _ctx.ruleform_size +
                                        index
                                    ]
                                  ,
                                                                  "onUpdate:modelValue": ($event: any) => (
                                    _ctx.DeviceChecked[
                                      (_ctx.ruleform_page - 1) * _ctx.ruleform_size +
                                        index
                                    ]
                                   = $event)
                                                                }, {
                                                                  default: _withId(() => [
                                                                    _hoisted_80
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                                                              ])
                                                            ]),
                                                            _hoisted_81,
                                                            _hoisted_82,
                                                            _hoisted_83,
                                                            _hoisted_84,
                                                            _createVNode("div", _hoisted_85, [
                                                              _hoisted_86,
                                                              _createVNode(_component_el_tooltip, {
                                                                effect: "dark",
                                                                content: "受邀账号之间请使用英文逗号分隔",
                                                                placement: "right"
                                                              }, {
                                                                default: _withId(() => [
                                                                  _hoisted_87
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _hoisted_88
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                              _createVNode(_component_el_space, { direction: "vertical deviceStyle" }, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.device_group, (device, device_index) => {
                                                    return (_openBlock(), _createBlock(_Fragment, { key: device_index }, [
                                                      (_ctx.check_device(device, task.device_group))
                                                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                            key: 0,
                                                            effect: "dark",
                                                            content: "同一场景设备不可重复",
                                                            placement: "left"
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_89
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true),
                                                      _createVNode("div", _hoisted_90, [
                                                        _createVNode(_component_el_checkbox, {
                                                          modelValue: device.enable,
                                                          "onUpdate:modelValue": ($event: any) => (device.enable = $event),
                                                          onChange: ($event: any) => (
                                  _ctx.otherDeviceChecked(
                                    _ctx.ruleForm.global_settings_task_group,
                                    (_ctx.ruleform_page - 1) * _ctx.ruleform_size + index
                                  )
                                ),
                                                          style: {"width":"40px","text-align":"left","margin-left":"15px"}
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                                                        _createVNode(_component_el_select, {
                                                          size: "mini",
                                                          modelValue: device.id,
                                                          "onUpdate:modelValue": ($event: any) => (device.id = $event),
                                                          placeholder: "选择设备",
                                                          filterable: "",
                                                          class: "device-form-item",
                                                          style: {"width":"150px"}
                                                        }, {
                                                          default: _withId(() => [
                                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getDeviceSpecs, (device_specs) => {
                                                              return (_openBlock(), _createBlock(_component_el_popover, {
                                                                key: device_specs.id,
                                                                placement: "right-start",
                                                                trigger: "hover",
                                                                content: 
                                    device_specs.name +
                                    ' - ' +
                                    (device_specs.level + 1) +
                                    '档机'
                                  
                                                              }, {
                                                                reference: _withId(() => [
                                                                  _createVNode(_component_el_option, {
                                                                    label: 
                                        device_specs.remark +
                                        ' - ' +
                                        device_specs.model
                                      ,
                                                                    value: device_specs.id
                                                                  }, {
                                                                    default: _withId(() => [
                                                                      _createVNode(_component_el_row, { style: {"align-items":"center"} }, {
                                                                        default: _withId(() => [
                                                                          _createVNode(_component_el_col, { span: 12 }, {
                                                                            default: _withId(() => [
                                                                              _createVNode("span", _hoisted_91, _toDisplayString(device_specs.remark +
                                            " - " +
                                            device_specs.model), 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024),
                                                                          _createVNode(_component_el_col, { span: 12 }, {
                                                                            default: _withId(() => [
                                                                              (
                                              device_specs.status1 === '离线'
                                            )
                                                                                ? (_openBlock(), _createBlock("i", _hoisted_92))
                                                                                : _createCommentVNode("", true),
                                                                              (
                                              device_specs.status1 === '占用'
                                            )
                                                                                ? (_openBlock(), _createBlock("i", _hoisted_93))
                                                                                : _createCommentVNode("", true),
                                                                              (
                                              device_specs.status1 ===
                                              '空闲/在线'
                                            )
                                                                                ? (_openBlock(), _createBlock("i", _hoisted_94))
                                                                                : _createCommentVNode("", true)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1024)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["label", "value"])
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["content"]))
                                                            }), 128))
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                                        _createVNode(_component_el_select, {
                                                          size: "mini",
                                                          modelValue: device.script,
                                                          "onUpdate:modelValue": ($event: any) => (device.script = $event),
                                                          filterable: "",
                                                          placeholder: "选择局内脚本",
                                                          class: "device-form-item"
                                                        }, {
                                                          default: _withId(() => [
                                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getScripts(task.scene_id), (script) => {
                                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                                key: script.script_id,
                                                                label: script.script_name,
                                                                value: script.script_id
                                                              }, null, 8, ["label", "value"]))
                                                            }), 128))
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                                        (_ctx.projectIsKing)
                                                          ? (_openBlock(), _createBlock(_component_el_select, {
                                                              key: 0,
                                                              size: "mini",
                                                              class: "device-form-item",
                                                              onChange: ($event: any) => (_ctx.heroChange(device)),
                                                              modelValue: device.hero_id,
                                                              "onUpdate:modelValue": ($event: any) => (device.hero_id = $event),
                                                              placeholder: "选择英雄",
                                                              filterable: ""
                                                            }, {
                                                              default: _withId(() => [
                                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_hreo, (hero) => {
                                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                                    key: hero.hero_id,
                                                                    label: hero.hero_name,
                                                                    value: hero.hero_id
                                                                  }, null, 8, ["label", "value"]))
                                                                }), 128))
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"]))
                                                          : _createCommentVNode("", true),
                                                        (_ctx.projectIsKing)
                                                          ? (_openBlock(), _createBlock(_component_el_select, {
                                                              key: 1,
                                                              size: "mini",
                                                              class: "device-form-item",
                                                              modelValue: device.skin_id,
                                                              "onUpdate:modelValue": ($event: any) => (device.skin_id = $event),
                                                              placeholder: "选择皮肤",
                                                              filterable: ""
                                                            }, {
                                                              default: _withId(() => [
                                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_skin(device.hero_id), (skin) => {
                                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                                    key: skin.skin_id,
                                                                    label: skin.skin_name,
                                                                    value: skin.skin_id
                                                                  }, null, 8, ["label", "value"]))
                                                                }), 128))
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                                          : _createCommentVNode("", true),
                                                        _createVNode(_component_el_input, {
                                                          modelValue: device.conditions.value,
                                                          "onUpdate:modelValue": ($event: any) => (device.conditions.value = $event),
                                                          modelModifiers: { number: true },
                                                          class: "device-form-item",
                                                          size: "mini",
                                                          placeholder: "请输入等待时长"
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                        _createVNode(_component_el_select, {
                                                          size: "mini",
                                                          modelValue: device.account,
                                                          "onUpdate:modelValue": ($event: any) => (device.account = $event),
                                                          placeholder: "选择登录账号",
                                                          class: "device-form-item"
                                                        }, {
                                                          default: _withId(() => [
                                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getAccounts, (account) => {
                                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                                key: account.account_id,
                                                                value: account.account_id,
                                                                label: account.account
                                                              }, null, 8, ["value", "label"]))
                                                            }), 128))
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                                        (_ctx.projectIsInvitee)
                                                          ? (_openBlock(), _createBlock(_component_el_input, {
                                                              key: 2,
                                                              modelValue: device.invitee,
                                                              "onUpdate:modelValue": ($event: any) => (device.invitee = $event),
                                                              class: "device-form-item",
                                                              size: "mini",
                                                              placeholder: "请输入受邀账号"
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                          : _createCommentVNode("", true),
                                                        _createVNode("div", null, [
                                                          _createVNode(_component_el_button, {
                                                            type: "primary",
                                                            size: "mini",
                                                            style: {"margin-right":"10px"},
                                                            onClick: ($event: any) => (
                                    _ctx.open(
                                      (_ctx.ruleform_page - 1) * _ctx.ruleform_size +
                                        index,
                                      device_index,
                                      _ctx.ruleForm
                                    )
                                  )
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_95
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["onClick"]),
                                                          _createVNode(_component_el_button, {
                                                            type: "danger",
                                                            size: "mini",
                                                            onClick: _withModifiers(($event: any) => (
                                    _ctx.removeDevice(device, task.device_group)
                                  ), ["prevent"])
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_96
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["onClick"])
                                                        ])
                                                      ])
                                                    ], 64))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode("div", _hoisted_97, [
                                                _createVNode(_component_el_button, {
                                                  onClick: ($event: any) => (_ctx.addDevice(task.device_group)),
                                                  type: "primary",
                                                  size: "mini"
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_98
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["index"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form, {
                                      inline: true,
                                      size: "mini"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_form_item, { label: "每页" }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: _ctx.ruleform_size,
                                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.ruleform_size = $event)),
                                              onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.source_current_change(true))),
                                              style: {"width":"55px","height":"28px"}
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, { label: "条场景" }),
                                        _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_pagination, {
                                              currentPage: _ctx.ruleform_page,
                                              "onUpdate:currentPage": _cache[27] || (_cache[27] = ($event: any) => (_ctx.ruleform_page = $event)),
                                              "page-size": _ctx.ruleform_size,
                                              layout: "total, prev, pager, next, jumper",
                                              total: _ctx.ruleForm.global_settings_task_group?.length
                                            }, null, 8, ["currentPage", "page-size", "total"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_collapse_item, { name: "2" }, {
                                title: _withId(() => [
                                  _createVNode(_component_el_space, { size: 15 }, {
                                    default: _withId(() => [
                                      _hoisted_99,
                                      _hoisted_100
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_101, [
                                    _createVNode(_component_el_card, {
                                      class: "box-card-task",
                                      shadow: "never"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_space, {
                                          direction: "vertical senior",
                                          alignment: "align-items: left;"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "定时任务配置",
                                                    size: "mini",
                                                    "label-width": "120px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_select, {
                                                        modelValue: _ctx.ruleForm.global_settings_trigger_type,
                                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.ruleForm.global_settings_trigger_type = $event)),
                                                        style: {"width":"130px"},
                                                        placeholder: "请选择启动方式",
                                                        onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.triggerChange(_ctx.ruleForm)))
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_option, {
                                                            label: "手动",
                                                            value: 0
                                                          }),
                                                          _createVNode(_component_el_option, {
                                                            label: "定时器",
                                                            value: 2
                                                          }),
                                                          _createVNode(_component_el_option, {
                                                            label: "自动监控流水线",
                                                            value: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  (_ctx.ruleForm.global_settings_trigger_type === 1)
                                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                        key: 0,
                                                        label: "流水线",
                                                        size: "mini",
                                                        "label-width": "55px"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_select, {
                                                            style: {"width":"130px"},
                                                            modelValue: _ctx.ruleForm.global_settings_trigger_value,
                                                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.ruleForm.global_settings_trigger_value = $event)),
                                                            placeholder: "请选择流水线",
                                                            onChange: _cache[31] || (_cache[31] = ($event: any) => (
                                  _ctx.ruleForm.global_settings_downloader_pipeline =
                                    _ctx.ruleForm.global_settings_trigger_value
                                ))
                                                          }, {
                                                            default: _withId(() => [
                                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPipelines, (pipeline) => {
                                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                                  key: pipeline.pipeline_id,
                                                                  label: pipeline.pipeline_name,
                                                                  value: pipeline.pipeline_id
                                                                }, null, 8, ["label", "value"]))
                                                              }), 128))
                                                            ]),
                                                            _: 1
                                                          }, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.ruleForm.global_settings_trigger_type === 1)
                                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                        key: 1,
                                                        label: "ios流水线",
                                                        size: "mini",
                                                        "label-width": "100px"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_select, {
                                                            style: {"width":"130px"},
                                                            modelValue: 
                                  _ctx.ruleForm.global_settings_trigger_ios_value
                                ,
                                                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (
                                  _ctx.ruleForm.global_settings_trigger_ios_value
                                 = $event)),
                                                            placeholder: "请选择ios流水线",
                                                            onChange: _cache[33] || (_cache[33] = ($event: any) => (
                                  _ctx.ruleForm.global_settings_downloader_pipeline2 =
                                    _ctx.ruleForm.global_settings_trigger_ios_value
                                ))
                                                          }, {
                                                            default: _withId(() => [
                                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPipelines, (pipeline) => {
                                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                                  key: pipeline.pipeline_id,
                                                                  label: pipeline.pipeline_name,
                                                                  value: pipeline.pipeline_id
                                                                }, null, 8, ["label", "value"]))
                                                              }), 128))
                                                            ]),
                                                            _: 1
                                                          }, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.ruleForm.global_settings_trigger_type === 1)
                                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                        key: 2,
                                                        label: "",
                                                        size: "mini"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_time_picker, {
                                                            modelValue: 
                                  _ctx.ruleForm.global_settings_downloader_time
                                ,
                                                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (
                                  _ctx.ruleForm.global_settings_downloader_time
                                 = $event)),
                                                            "is-range": "",
                                                            "range-separator": "To",
                                                            "start-placeholder": "Start time",
                                                            "end-placeholder": "End time",
                                                            format: "HH:mm"
                                                          }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.ruleForm.global_settings_trigger_type === 2)
                                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                        key: 3,
                                                        label: "周期",
                                                        size: "mini",
                                                        "label-width": "40px"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_space, { size: 15 }, {
                                                            default: _withId(() => [
                                                              _createVNode(_component_el_select, {
                                                                modelValue: 
                                    _ctx.ruleForm.global_settings_trigger_value_interval
                                  ,
                                                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (
                                    _ctx.ruleForm.global_settings_trigger_value_interval
                                   = $event)),
                                                                style: {"width":"110px"},
                                                                placeholder: "选择周期",
                                                                onChange: _cache[36] || (_cache[36] = ($event: any) => (_ctx.triggerTypeChange(_ctx.ruleForm)))
                                                              }, {
                                                                default: _withId(() => [
                                                                  _createVNode(_component_el_option, {
                                                                    label: "周",
                                                                    value: "week"
                                                                  }),
                                                                  _createVNode(_component_el_option, {
                                                                    label: "天",
                                                                    value: "day"
                                                                  }),
                                                                  _createVNode(_component_el_option, {
                                                                    label: "小时",
                                                                    value: "hour"
                                                                  })
                                                                ]),
                                                                _: 1
                                                              }, 8, ["modelValue"]),
                                                              (
                                    _ctx.ruleForm.global_settings_trigger_value_interval ===
                                    'week'
                                  )
                                                                ? (_openBlock(), _createBlock(_component_el_select, {
                                                                    key: 0,
                                                                    modelValue: 
                                    _ctx.ruleForm.global_settings_trigger_value_day
                                  ,
                                                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (
                                    _ctx.ruleForm.global_settings_trigger_value_day
                                   = $event)),
                                                                    style: {"width":"110px"},
                                                                    placeholder: "请选择"
                                                                  }, {
                                                                    default: _withId(() => [
                                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.day_options, (item) => {
                                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                                          key: item.label,
                                                                          label: item.label,
                                                                          value: item.value
                                                                        }, null, 8, ["label", "value"]))
                                                                      }), 128))
                                                                    ]),
                                                                    _: 1
                                                                  }, 8, ["modelValue"]))
                                                                : _createCommentVNode("", true),
                                                              (
                                    _ctx.ruleForm.global_settings_trigger_value_interval !==
                                    'hour'
                                  )
                                                                ? (_openBlock(), _createBlock(_component_el_time_select, {
                                                                    key: 1,
                                                                    style: {"width":"110px"},
                                                                    modelValue: 
                                    _ctx.ruleForm.global_settings_trigger_value_time
                                  ,
                                                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (
                                    _ctx.ruleForm.global_settings_trigger_value_time
                                   = $event)),
                                                                    start: "00:01",
                                                                    step: "00:01",
                                                                    end: "23:59",
                                                                    placeholder: _ctx.time_placeholder
                                                                  }, null, 8, ["modelValue", "placeholder"]))
                                                                : _createCommentVNode("", true),
                                                              (
                                    _ctx.ruleForm.global_settings_trigger_value_interval ===
                                    'hour'
                                  )
                                                                ? (_openBlock(), _createBlock(_component_el_time_select, {
                                                                    key: 2,
                                                                    style: {"width":"110px"},
                                                                    modelValue: 
                                    _ctx.ruleForm.global_settings_trigger_value_time
                                  ,
                                                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (
                                    _ctx.ruleForm.global_settings_trigger_value_time
                                   = $event)),
                                                                    start: "00:01",
                                                                    step: "00:01",
                                                                    end: "00:59",
                                                                    placeholder: _ctx.time_placeholder
                                                                  }, null, 8, ["modelValue", "placeholder"]))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form, null, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_form_item, {
                                                        label: "安装包自动下载",
                                                        size: "mini",
                                                        "label-width": "120px"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_select, {
                                                            modelValue: 
                                    _ctx.ruleForm.global_settings_downloader_type
                                  ,
                                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (
                                    _ctx.ruleForm.global_settings_downloader_type
                                   = $event)),
                                                            disabled: 
                                    _ctx.ruleForm.global_settings_trigger_type === 1
                                  ,
                                                            style: {"width":"130px"},
                                                            onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.downloderTypeChange(_ctx.ruleForm))),
                                                            placeholder: "请选择安装方式"
                                                          }, {
                                                            default: _withId(() => [
                                                              _createVNode(_component_el_option, {
                                                                label: "手动",
                                                                value: 0
                                                              }),
                                                              _createVNode(_component_el_option, {
                                                                label: "流水线",
                                                                value: 1
                                                              }),
                                                              _createVNode(_component_el_option, {
                                                                label: "指定流水线版本",
                                                                value: 2
                                                              })
                                                            ]),
                                                            _: 1
                                                          }, 8, ["modelValue", "disabled"])
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_el_space, { style: {"margin-top":"14px"} }, {
                                                        default: _withId(() => [
                                                          (
                                    _ctx.ruleForm.global_settings_downloader_type ===
                                      2 ||
                                    _ctx.ruleForm.global_settings_downloader_type ===
                                      1
                                  )
                                                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                                key: 0,
                                                                label: "Android流水线",
                                                                size: "mini",
                                                                "label-width": "120px"
                                                              }, {
                                                                default: _withId(() => [
                                                                  _createVNode(_component_el_select, {
                                                                    style: {"width":"130px"},
                                                                    modelValue: 
                                      _ctx.ruleForm.global_settings_downloader_pipeline
                                    ,
                                                                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (
                                      _ctx.ruleForm.global_settings_downloader_pipeline
                                     = $event)),
                                                                    disabled: 
                                      _ctx.ruleForm.global_settings_trigger_type ===
                                      1
                                    ,
                                                                    placeholder: "请选择流水线",
                                                                    clearable: "",
                                                                    onChange: _cache[43] || (_cache[43] = ($event: any) => (
                                      _ctx.ruleForm.global_settings_downloader_build_id =
                                        ''
                                    ))
                                                                  }, {
                                                                    default: _withId(() => [
                                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPipelines, (pipeline) => {
                                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                                          key: pipeline.pipeline_id,
                                                                          label: pipeline.pipeline_name,
                                                                          value: pipeline.pipeline_id
                                                                        }, null, 8, ["label", "value"]))
                                                                      }), 128))
                                                                    ]),
                                                                    _: 1
                                                                  }, 8, ["modelValue", "disabled"])
                                                                ]),
                                                                _: 1
                                                              }))
                                                            : _createCommentVNode("", true),
                                                          (
                                    _ctx.ruleForm.global_settings_downloader_type ===
                                    2
                                  )
                                                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                                key: 1,
                                                                label: "构建号",
                                                                size: "mini",
                                                                "label-width": "55px"
                                                              }, {
                                                                default: _withId(() => [
                                                                  _createVNode(_component_el_select, {
                                                                    style: {"width":"130px"},
                                                                    modelValue: 
                                      _ctx.ruleForm.global_settings_downloader_build_id
                                    ,
                                                                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (
                                      _ctx.ruleForm.global_settings_downloader_build_id
                                     = $event)),
                                                                    placeholder: "请选择构建号",
                                                                    clearable: ""
                                                                  }, {
                                                                    default: _withId(() => [
                                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPiplinePkgs(
                                        _ctx.ruleForm.global_settings_downloader_pipeline
                                      ), (pkg) => {
                                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                                          key: pkg.build_num,
                                                                          label: pkg.build_num,
                                                                          value: pkg.build_num
                                                                        }, null, 8, ["label", "value"]))
                                                                      }), 128))
                                                                    ]),
                                                                    _: 1
                                                                  }, 8, ["modelValue"])
                                                                ]),
                                                                _: 1
                                                              }))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_el_space, { style: {"margin-top":"9px"} }, {
                                                        default: _withId(() => [
                                                          (
                                    _ctx.ruleForm.global_settings_downloader_type ===
                                      2 ||
                                    _ctx.ruleForm.global_settings_downloader_type ===
                                      1
                                  )
                                                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                                key: 0,
                                                                label: "iOS流水线",
                                                                size: "mini",
                                                                "label-width": "120px"
                                                              }, {
                                                                default: _withId(() => [
                                                                  _createVNode(_component_el_select, {
                                                                    style: {"width":"130px"},
                                                                    modelValue: 
                                      _ctx.ruleForm.global_settings_downloader_pipeline2
                                    ,
                                                                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (
                                      _ctx.ruleForm.global_settings_downloader_pipeline2
                                     = $event)),
                                                                    disabled: 
                                      _ctx.ruleForm.global_settings_trigger_type ===
                                      1
                                    ,
                                                                    placeholder: "请选择流水线",
                                                                    clearable: "",
                                                                    onChange: _cache[46] || (_cache[46] = ($event: any) => (
                                      _ctx.ruleForm.global_settings_downloader_build_id2 =
                                        ''
                                    ))
                                                                  }, {
                                                                    default: _withId(() => [
                                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPipelines, (pipeline) => {
                                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                                          key: pipeline.pipeline_id,
                                                                          label: pipeline.pipeline_name,
                                                                          value: pipeline.pipeline_id
                                                                        }, null, 8, ["label", "value"]))
                                                                      }), 128))
                                                                    ]),
                                                                    _: 1
                                                                  }, 8, ["modelValue", "disabled"])
                                                                ]),
                                                                _: 1
                                                              }))
                                                            : _createCommentVNode("", true),
                                                          (
                                    _ctx.ruleForm.global_settings_downloader_type ===
                                    2
                                  )
                                                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                                key: 1,
                                                                label: "构建号",
                                                                size: "mini",
                                                                "label-width": "55px"
                                                              }, {
                                                                default: _withId(() => [
                                                                  _createVNode(_component_el_select, {
                                                                    style: {"width":"130px"},
                                                                    modelValue: 
                                      _ctx.ruleForm.global_settings_downloader_build_id2
                                    ,
                                                                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (
                                      _ctx.ruleForm.global_settings_downloader_build_id2
                                     = $event)),
                                                                    placeholder: "请选择构建号",
                                                                    clearable: ""
                                                                  }, {
                                                                    default: _withId(() => [
                                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPiplinePkgs(
                                        _ctx.ruleForm.global_settings_downloader_pipeline2
                                      ), (pkg) => {
                                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                                          key: pkg.build_num,
                                                                          label: pkg.build_num,
                                                                          value: pkg.build_num
                                                                        }, null, 8, ["label", "value"]))
                                                                      }), 128))
                                                                    ]),
                                                                    _: 1
                                                                  }, 8, ["modelValue"])
                                                                ]),
                                                                _: 1
                                                              }))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _hoisted_102,
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "设备离线自动取消任务",
                                                    size: "mini",
                                                    "label-width": "150px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_checkbox, {
                                                        modelValue: _ctx.ruleForm.is_cancel,
                                                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_ctx.ruleForm.is_cancel = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "不推送资源包",
                                                    size: "mini",
                                                    "label-width": "150px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_checkbox, {
                                                        modelValue: _ctx.ruleForm.no_push_resources,
                                                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (_ctx.ruleForm.no_push_resources = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "不安装",
                                                    size: "mini",
                                                    "label-width": "150px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_checkbox, {
                                                        modelValue: _ctx.ruleForm.no_install,
                                                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.ruleForm.no_install = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "开启自动截帧",
                                                    size: "mini",
                                                    "label-width": "150px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_checkbox, {
                                                        modelValue: _ctx.ruleForm.screenshot,
                                                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.ruleForm.screenshot = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "任务完成生成报告",
                                                    size: "mini",
                                                    "label-width": "150px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_checkbox, {
                                                        modelValue: _ctx.ruleForm.generate_report,
                                                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.ruleForm.generate_report = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "设备离线正常启动任务",
                                                    size: "mini",
                                                    "label-width": "150px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_checkbox, {
                                                        modelValue: _ctx.ruleForm.ignore_device_offline,
                                                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (_ctx.ruleForm.ignore_device_offline = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, { style: {"margin-top":"9px"} }, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "报告类型",
                                                    size: "mini",
                                                    "label-width": "120px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_select, {
                                                        style: {"width":"130px"},
                                                        modelValue: _ctx.ruleForm.report_type,
                                                        "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_ctx.ruleForm.report_type = $event)),
                                                        onChange: _cache[55] || (_cache[55] = ($event: any) => (
                                  [9, 13].indexOf(_ctx.ruleForm.subtype) != -1
                                    ? (_ctx.ruleForm.subtype = '')
                                    : (_ctx.ruleForm.subtype = '0')
                                ))
                                                      }, {
                                                        default: _withId(() => [
                                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_type, (item, index) => {
                                                            return (_openBlock(), _createBlock(_component_el_option, {
                                                              key: index,
                                                              label: item.name,
                                                              value: item.value
                                                            }, null, 8, ["label", "value"]))
                                                          }), 128))
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  (
                                _ctx.ruleForm.report_type != 13 &&
                                _ctx.ruleForm.report_type != 9
                              )
                                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                        key: 0,
                                                        label: "子类型",
                                                        size: "mini",
                                                        "label-width": "55px"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_select, {
                                                            style: {"width":"130px"},
                                                            modelValue: _ctx.ruleForm.subtype,
                                                            "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_ctx.ruleForm.subtype = $event)),
                                                            placeholder: ""
                                                          }, {
                                                            default: _withId(() => [
                                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subList1, (item, index) => {
                                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                                  key: index,
                                                                  label: item.name,
                                                                  value: item.value
                                                                }, null, 8, ["label", "value"]))
                                                              }), 128))
                                                            ]),
                                                            _: 1
                                                          }, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : (_ctx.ruleForm.report_type == 9)
                                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                          key: 1,
                                                          label: "子类型",
                                                          size: "mini",
                                                          "label-width": "55px"
                                                        }, {
                                                          default: _withId(() => [
                                                            _createVNode(_component_el_select, {
                                                              style: {"width":"130px"},
                                                              modelValue: _ctx.ruleForm.subtype,
                                                              "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.ruleForm.subtype = $event)),
                                                              placeholder: ""
                                                            }, {
                                                              default: _withId(() => [
                                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subList, (item, index) => {
                                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                                    key: index,
                                                                    label: item.name,
                                                                    value: item.value
                                                                  }, null, 8, ["label", "value"]))
                                                                }), 128))
                                                              ]),
                                                              _: 1
                                                            }, 8, ["modelValue"])
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : (_ctx.ruleForm.report_type == 13)
                                                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                            key: 2,
                                                            label: "子类型",
                                                            size: "mini",
                                                            "label-width": "55px"
                                                          }, {
                                                            default: _withId(() => [
                                                              _createVNode(_component_el_select, {
                                                                style: {"width":"130px"},
                                                                modelValue: _ctx.ruleForm.subtype,
                                                                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (_ctx.ruleForm.subtype = $event)),
                                                                placeholder: ""
                                                              }, {
                                                                default: _withId(() => [
                                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subList3, (item, index) => {
                                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                                      key: index,
                                                                      label: item.name,
                                                                      value: item.value
                                                                    }, null, 8, ["label", "value"]))
                                                                  }), 128))
                                                                ]),
                                                                _: 1
                                                              }, 8, ["modelValue"])
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, { style: {"margin-top":"9px"} }, {
                                                default: _withId(() => [
                                                  _createVNode("div", _hoisted_103, [
                                                    _createVNode(_component_el_button, {
                                                      onClick: _ctx.open1,
                                                      type: "primary",
                                                      size: "mini"
                                                    }, {
                                                      default: _withId(() => [
                                                        _hoisted_104
                                                      ]),
                                                      _: 1
                                                    }, 8, ["onClick"])
                                                  ]),
                                                  _createVNode(_component_el_select, {
                                                    style: {"width":"130px","margin":"0px 20px"},
                                                    size: "mini",
                                                    modelValue: _ctx.ruleForm.upload_svn,
                                                    "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (_ctx.ruleForm.upload_svn = $event))
                                                  }, {
                                                    default: _withId(() => [
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.upload_svn, (item, index) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: index,
                                                          label: item.name,
                                                          value: item.value
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"]),
                                                  (_ctx.ruleForm.upload_svn != false)
                                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                        key: 0,
                                                        label: "输入值",
                                                        size: "mini",
                                                        "label-width": "55px"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_input, {
                                                            modelValue: _ctx.ruleForm.svn_dir,
                                                            "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (_ctx.ruleForm.svn_dir = $event)),
                                                            class: "device-form-item",
                                                            size: "mini"
                                                          }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "关闭异常检测",
                                                    size: "mini",
                                                    "label-width": "150px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_checkbox, {
                                                        modelValue: _ctx.ruleForm.except_check,
                                                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (_ctx.ruleForm.except_check = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "开启sampleProfiler",
                                                    size: "mini",
                                                    "label-width": "150px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_checkbox, {
                                                        modelValue: _ctx.ruleForm.sampleProfiler,
                                                        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (_ctx.ruleForm.sampleProfiler = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "开启GpuCounter",
                                                    size: "mini",
                                                    "label-width": "150px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_checkbox, {
                                                        modelValue: _ctx.ruleForm.GpuCounter,
                                                        "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (_ctx.ruleForm.GpuCounter = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "开启perfetto",
                                                    size: "mini",
                                                    "label-width": "150px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_checkbox, {
                                                        modelValue: _ctx.ruleForm.perfetto,
                                                        "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_ctx.ruleForm.perfetto = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "安装包",
                                                    size: "mini",
                                                    "label-width": "120px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_input, {
                                                        class: "pkg_input",
                                                        size: "mini",
                                                        modelValue: _ctx.ruleForm.pkg_name_by_manual,
                                                        "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (_ctx.ruleForm.pkg_name_by_manual = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode(_component_el_space, null, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "流水线触发任务每日限一次",
                                                    size: "mini",
                                                    "label-width": "182px"
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_checkbox, {
                                                        modelValue: _ctx.ruleForm.pipeline_auto_one,
                                                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => (_ctx.ruleForm.pipeline_auto_one = $event))
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_collapse_item, { name: "3" }, {
                                title: _withId(() => [
                                  _createVNode(_component_el_space, { size: 15 }, {
                                    default: _withId(() => [
                                      _hoisted_105,
                                      _hoisted_106
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_107, [
                                    _createVNode("section", null, [
                                      _createVNode(_component_el_card, {
                                        shadow: "never",
                                        class: "reportDisplay"
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_108,
                                          _createVNode("ul", null, [
                                            _createVNode("li", null, [
                                              _hoisted_109,
                                              _createVNode(_component_el_tooltip, {
                                                effect: "dark",
                                                content: "测试报告中核心指标表格中呈现的指标",
                                                placement: "top"
                                              }, {
                                                default: _withId(() => [
                                                  _hoisted_110
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("li", null, [
                                              _createVNode(_component_el_row, null, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content
                                  .core_index, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_tag, {
                                                      key: item,
                                                      effect: "plain",
                                                      closable: "",
                                                      onClose: ($event: any) => (_ctx.handleClose(item, 'core_index'))
                                                    }, {
                                                      default: _withId(() => [
                                                        _createTextVNode(_toDisplayString(item), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClose"]))
                                                  }), 128)),
                                                  _createVNode(_component_el_select, {
                                                    modelValue: _ctx.report_settings.content.core_index,
                                                    "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => (_ctx.report_settings.content.core_index = $event)),
                                                    multiple: "",
                                                    "collapse-tags": "",
                                                    placeholder: "请选择",
                                                    style: {"height":"32px"}
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_row, {
                                                        justify: "space-around",
                                                        type: "flex"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            class: "select-tag-class",
                                                            style: {"width":"48%"},
                                                            onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.handleClearAll('core_index')))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_111
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            style: {"width":"48%"},
                                                            class: "select-tag-class",
                                                            onClick: _cache[68] || (_cache[68] = ($event: any) => (
                                      _ctx.handleSelectAll(
                                        'core_index',
                                        _ctx.get_all_indexes
                                      )
                                    ))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_112
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: item,
                                                          label: item,
                                                          value: item
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _createVNode("ul", null, [
                                            _createVNode("li", null, [
                                              _hoisted_113,
                                              _createVNode(_component_el_tooltip, {
                                                effect: "dark",
                                                content: "测试报告中核心指标表格中呈现的场景，默认呈现所有测试过的场景",
                                                placement: "top"
                                              }, {
                                                default: _withId(() => [
                                                  _hoisted_114
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("li", null, [
                                              _createVNode(_component_el_row, null, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content
                                  .core_scene, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_tag, {
                                                      key: item,
                                                      effect: "plain",
                                                      closable: "",
                                                      onClose: ($event: any) => (_ctx.handleClose(item, 'core_scene'))
                                                    }, {
                                                      default: _withId(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.get_scene_chinese(item)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClose"]))
                                                  }), 128)),
                                                  _createVNode(_component_el_select, {
                                                    modelValue: _ctx.report_settings.content.core_scene,
                                                    "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => (_ctx.report_settings.content.core_scene = $event)),
                                                    multiple: "",
                                                    "collapse-tags": "",
                                                    placeholder: "请选择",
                                                    style: {"height":"32px"}
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_row, {
                                                        justify: "space-around",
                                                        type: "flex"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            class: "select-tag-class",
                                                            style: {"width":"48%"},
                                                            onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.handleClearAll('core_scene')))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_115
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            style: {"width":"48%"},
                                                            class: "select-tag-class",
                                                            onClick: _cache[71] || (_cache[71] = ($event: any) => (
                                      _ctx.handleSelectAll(
                                        'core_scene',
                                        _ctx.get_form_scene(
                                          _ctx.ruleForm.global_settings_task_group
                                        )
                                      )
                                    ))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_116
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_form_scene(
                                    _ctx.ruleForm.global_settings_task_group
                                  ), (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: item.id,
                                                          label: item.chinese,
                                                          value: item.id
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _createVNode("ul", null, [
                                            _createVNode("li", null, [
                                              _hoisted_117,
                                              _createVNode(_component_el_tooltip, {
                                                effect: "dark",
                                                content: "测试报告中呈现趋势图的指标",
                                                placement: "top"
                                              }, {
                                                default: _withId(() => [
                                                  _hoisted_118
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("li", null, [
                                              _createVNode(_component_el_row, null, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content
                                  .trend_index, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_tag, {
                                                      key: item,
                                                      effect: "plain",
                                                      closable: "",
                                                      onClose: ($event: any) => (_ctx.handleClose(item, 'trend_index'))
                                                    }, {
                                                      default: _withId(() => [
                                                        _createTextVNode(_toDisplayString(item), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClose"]))
                                                  }), 128)),
                                                  _createVNode(_component_el_select, {
                                                    modelValue: _ctx.report_settings.content.trend_index,
                                                    "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => (_ctx.report_settings.content.trend_index = $event)),
                                                    multiple: "",
                                                    "collapse-tags": "",
                                                    placeholder: "请选择",
                                                    style: {"height":"32px"}
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_row, {
                                                        justify: "space-around",
                                                        type: "flex"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            class: "select-tag-class",
                                                            style: {"width":"48%"},
                                                            onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.handleClearAll('trend_index')))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_119
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            style: {"width":"48%"},
                                                            class: "select-tag-class",
                                                            onClick: _cache[74] || (_cache[74] = ($event: any) => (
                                      _ctx.handleSelectAll(
                                        'trend_index',
                                        _ctx.get_all_indexes
                                      )
                                    ))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_120
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: item,
                                                          label: item,
                                                          value: item
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _createVNode("ul", null, [
                                            _createVNode("li", null, [
                                              _hoisted_121,
                                              _createVNode(_component_el_tooltip, {
                                                effect: "dark",
                                                content: "测试报告中呈现趋势图的场景，默认仅呈现第一个场景",
                                                placement: "top"
                                              }, {
                                                default: _withId(() => [
                                                  _hoisted_122
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("li", null, [
                                              _createVNode(_component_el_row, null, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content
                                  .trend_scene, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_tag, {
                                                      key: item,
                                                      effect: "plain",
                                                      closable: "",
                                                      onClose: ($event: any) => (_ctx.handleClose(item, 'trend_scene'))
                                                    }, {
                                                      default: _withId(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.get_scene_chinese(item)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClose"]))
                                                  }), 128)),
                                                  _createVNode(_component_el_select, {
                                                    modelValue: _ctx.report_settings.content.trend_scene,
                                                    "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (_ctx.report_settings.content.trend_scene = $event)),
                                                    multiple: "",
                                                    "collapse-tags": "",
                                                    placeholder: "请选择",
                                                    style: {"height":"32px"}
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_row, {
                                                        justify: "space-around",
                                                        type: "flex"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            class: "select-tag-class",
                                                            style: {"width":"48%"},
                                                            onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.handleClearAll('trend_scene')))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_123
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            style: {"width":"48%"},
                                                            class: "select-tag-class",
                                                            onClick: _cache[77] || (_cache[77] = ($event: any) => (
                                      _ctx.handleSelectAll(
                                        'trend_scene',
                                        _ctx.get_form_scene(
                                          _ctx.ruleForm.global_settings_task_group
                                        )
                                      )
                                    ))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_124
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_form_scene(
                                    _ctx.ruleForm.global_settings_task_group
                                  ), (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: item.id,
                                                          label: item.chinese,
                                                          value: item.id
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _createVNode("ul", null, [
                                            _createVNode("li", null, [
                                              _hoisted_125,
                                              _createVNode(_component_el_tooltip, {
                                                effect: "dark",
                                                content: "配置的场景不会在测试报告中出现",
                                                placement: "top"
                                              }, {
                                                default: _withId(() => [
                                                  _hoisted_126
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("li", null, [
                                              _createVNode(_component_el_row, null, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content
                                  .exclude_scene, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_tag, {
                                                      key: item,
                                                      effect: "plain",
                                                      closable: "",
                                                      onClose: ($event: any) => (_ctx.handleClose(item, 'exclude_scene'))
                                                    }, {
                                                      default: _withId(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.get_scene_chinese(item)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClose"]))
                                                  }), 128)),
                                                  _createVNode(_component_el_select, {
                                                    modelValue: _ctx.report_settings.content.exclude_scene,
                                                    "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => (_ctx.report_settings.content.exclude_scene = $event)),
                                                    multiple: "",
                                                    "collapse-tags": "",
                                                    placeholder: "请选择",
                                                    style: {"height":"32px"}
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_row, {
                                                        justify: "space-around",
                                                        type: "flex"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            class: "select-tag-class",
                                                            style: {"width":"48%"},
                                                            onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.handleClearAll('exclude_scene')))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_127
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            style: {"width":"48%"},
                                                            class: "select-tag-class",
                                                            onClick: _cache[80] || (_cache[80] = ($event: any) => (
                                      _ctx.handleSelectAll(
                                        'exclude_scene',
                                        _ctx.getProjectScenes
                                      )
                                    ))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_128
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getProjectScenes, (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: item.id,
                                                          label: item.chinese,
                                                          value: item.id
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _createVNode("ul", null, [
                                            _createVNode("li", null, [
                                              _hoisted_129,
                                              _createVNode(_component_el_tooltip, {
                                                effect: "dark",
                                                content: "配置的设备不会在测试报告中出现",
                                                placement: "top"
                                              }, {
                                                default: _withId(() => [
                                                  _hoisted_130
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("li", null, [
                                              _createVNode(_component_el_row, null, {
                                                default: _withId(() => [
                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content
                                  .exclude_device, (item) => {
                                                    return (_openBlock(), _createBlock(_component_el_tag, {
                                                      key: item,
                                                      effect: "plain",
                                                      closable: "",
                                                      onClose: ($event: any) => (_ctx.handleClose(item, 'exclude_device'))
                                                    }, {
                                                      default: _withId(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.get_device_model(item)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClose"]))
                                                  }), 128)),
                                                  _createVNode(_component_el_select, {
                                                    modelValue: _ctx.report_settings.content.exclude_device,
                                                    "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => (_ctx.report_settings.content.exclude_device = $event)),
                                                    multiple: "",
                                                    "collapse-tags": "",
                                                    placeholder: "请选择",
                                                    style: {"height":"32px"}
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_row, {
                                                        justify: "space-around",
                                                        type: "flex"
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            class: "select-tag-class",
                                                            style: {"width":"48%"},
                                                            onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.handleClearAll('exclude_device')))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_131
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_el_tag, {
                                                            type: "primary",
                                                            style: {"width":"48%"},
                                                            class: "select-tag-class",
                                                            onClick: _cache[83] || (_cache[83] = ($event: any) => (
                                      _ctx.handleSelectAll(
                                        'exclude_device',
                                        _ctx.getDeviceSpecs
                                      )
                                    ))
                                                          }, {
                                                            default: _withId(() => [
                                                              _hoisted_132
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getDeviceSpecs, (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                          key: item.id,
                                                          label: item.level + '档机-' + item.model,
                                                          value: item.id
                                                        }, null, 8, ["label", "value"]))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _createVNode("ul", _hoisted_133, [
                                            _createVNode("li", null, [
                                              _hoisted_134,
                                              _createVNode(_component_el_tooltip, {
                                                effect: "dark",
                                                content: "测试报告中的详细数据模块会按照配置的指标分类呈现",
                                                placement: "top"
                                              }, {
                                                default: _withId(() => [
                                                  _hoisted_135
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _createVNode("div", null, [
                                              _createVNode("ul", null, [
                                                _hoisted_136,
                                                _createVNode("li", null, [
                                                  _createVNode(_component_el_row, null, {
                                                    default: _withId(() => [
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content
                                      .index_type.basic, (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_tag, {
                                                          key: item,
                                                          effect: "plain",
                                                          closable: "",
                                                          onClose: ($event: any) => (_ctx.handleClose(item, 'basic'))
                                                        }, {
                                                          default: _withId(() => [
                                                            _createTextVNode(_toDisplayString(item), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClose"]))
                                                      }), 128)),
                                                      _createVNode(_component_el_select, {
                                                        modelValue: 
                                      _ctx.report_settings.content.index_type.basic
                                    ,
                                                        "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => (
                                      _ctx.report_settings.content.index_type.basic
                                     = $event)),
                                                        multiple: "",
                                                        "collapse-tags": "",
                                                        placeholder: "请选择",
                                                        style: {"height":"32px"}
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_row, {
                                                            justify: "space-around",
                                                            type: "flex"
                                                          }, {
                                                            default: _withId(() => [
                                                              _createVNode(_component_el_tag, {
                                                                type: "primary",
                                                                class: "select-tag-class",
                                                                style: {"width":"48%"},
                                                                onClick: _cache[85] || (_cache[85] = ($event: any) => (_ctx.handleClearAll('basic')))
                                                              }, {
                                                                default: _withId(() => [
                                                                  _hoisted_137
                                                                ]),
                                                                _: 1
                                                              }),
                                                              _createVNode(_component_el_tag, {
                                                                type: "primary",
                                                                style: {"width":"48%"},
                                                                class: "select-tag-class",
                                                                onClick: _cache[86] || (_cache[86] = ($event: any) => (
                                          _ctx.handleSelectAll(
                                            'basic',
                                            _ctx.get_all_indexes
                                          )
                                        ))
                                                              }, {
                                                                default: _withId(() => [
                                                                  _hoisted_138
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }),
                                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                                            return (_openBlock(), _createBlock(_component_el_option, {
                                                              key: item,
                                                              label: item,
                                                              value: item,
                                                              disabled: 
                                        _ctx.get_detailed_indexes('basic', item)
                                      
                                                            }, null, 8, ["label", "value", "disabled"]))
                                                          }), 128))
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createVNode("ul", null, [
                                                _hoisted_139,
                                                _createVNode("li", null, [
                                                  _createVNode(_component_el_row, null, {
                                                    default: _withId(() => [
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content
                                      .index_type.advance, (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_tag, {
                                                          key: item,
                                                          effect: "plain",
                                                          closable: "",
                                                          onClose: ($event: any) => (_ctx.handleClose(item, 'advance'))
                                                        }, {
                                                          default: _withId(() => [
                                                            _createTextVNode(_toDisplayString(item), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClose"]))
                                                      }), 128)),
                                                      _createVNode(_component_el_select, {
                                                        modelValue: 
                                      _ctx.report_settings.content.index_type.advance
                                    ,
                                                        "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => (
                                      _ctx.report_settings.content.index_type.advance
                                     = $event)),
                                                        multiple: "",
                                                        "collapse-tags": "",
                                                        placeholder: "请选择",
                                                        style: {"height":"32px"}
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_row, {
                                                            justify: "space-around",
                                                            type: "flex"
                                                          }, {
                                                            default: _withId(() => [
                                                              _createVNode(_component_el_tag, {
                                                                type: "primary",
                                                                class: "select-tag-class",
                                                                style: {"width":"48%"},
                                                                onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.handleClearAll('advance')))
                                                              }, {
                                                                default: _withId(() => [
                                                                  _hoisted_140
                                                                ]),
                                                                _: 1
                                                              }),
                                                              _createVNode(_component_el_tag, {
                                                                type: "primary",
                                                                style: {"width":"48%"},
                                                                class: "select-tag-class",
                                                                onClick: _cache[89] || (_cache[89] = ($event: any) => (
                                          _ctx.handleSelectAll(
                                            'advance',
                                            _ctx.get_all_indexes
                                          )
                                        ))
                                                              }, {
                                                                default: _withId(() => [
                                                                  _hoisted_141
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }),
                                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                                            return (_openBlock(), _createBlock(_component_el_option, {
                                                              key: item,
                                                              label: item,
                                                              value: item,
                                                              disabled: 
                                        _ctx.get_detailed_indexes('advance', item)
                                      
                                                            }, null, 8, ["label", "value", "disabled"]))
                                                          }), 128))
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createVNode("ul", null, [
                                                _hoisted_142,
                                                _createVNode("li", null, [
                                                  _createVNode(_component_el_row, null, {
                                                    default: _withId(() => [
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_settings.content
                                      .index_type.customize, (item) => {
                                                        return (_openBlock(), _createBlock(_component_el_tag, {
                                                          key: item,
                                                          effect: "plain",
                                                          closable: "",
                                                          onClose: ($event: any) => (_ctx.handleClose(item, 'customize'))
                                                        }, {
                                                          default: _withId(() => [
                                                            _createTextVNode(_toDisplayString(item), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClose"]))
                                                      }), 128)),
                                                      _createVNode(_component_el_select, {
                                                        modelValue: 
                                      _ctx.report_settings.content.index_type
                                        .customize
                                    ,
                                                        "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => (
                                      _ctx.report_settings.content.index_type
                                        .customize
                                     = $event)),
                                                        multiple: "",
                                                        "collapse-tags": "",
                                                        placeholder: "请选择",
                                                        style: {"height":"32px"}
                                                      }, {
                                                        default: _withId(() => [
                                                          _createVNode(_component_el_row, {
                                                            justify: "space-around",
                                                            type: "flex"
                                                          }, {
                                                            default: _withId(() => [
                                                              _createVNode(_component_el_tag, {
                                                                type: "primary",
                                                                class: "select-tag-class",
                                                                style: {"width":"48%"},
                                                                onClick: _cache[91] || (_cache[91] = ($event: any) => (_ctx.handleClearAll('customize')))
                                                              }, {
                                                                default: _withId(() => [
                                                                  _hoisted_143
                                                                ]),
                                                                _: 1
                                                              }),
                                                              _createVNode(_component_el_tag, {
                                                                type: "primary",
                                                                style: {"width":"48%"},
                                                                class: "select-tag-class",
                                                                onClick: _cache[92] || (_cache[92] = ($event: any) => (
                                          _ctx.handleSelectAll(
                                            'customize',
                                            _ctx.get_all_indexes
                                          )
                                        ))
                                                              }, {
                                                                default: _withId(() => [
                                                                  _hoisted_144
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }),
                                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_all_indexes, (item) => {
                                                            return (_openBlock(), _createBlock(_component_el_option, {
                                                              key: item,
                                                              label: item,
                                                              value: item,
                                                              disabled: 
                                        _ctx.get_detailed_indexes('customize', item)
                                      
                                                            }, null, 8, ["label", "value", "disabled"]))
                                                          }), 128))
                                                        ]),
                                                        _: 1
                                                      }, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createVNode("ul", null, [
                                                _hoisted_145,
                                                _createVNode("li", null, [
                                                  _createVNode(_component_el_checkbox, {
                                                    modelValue: 
                                    _ctx.report_settings.content.trend_integrity
                                  ,
                                                    "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => (
                                    _ctx.report_settings.content.trend_integrity
                                   = $event))
                                                  }, null, 8, ["modelValue"])
                                                ])
                                              ]),
                                              _createVNode("ul", null, [
                                                _hoisted_146,
                                                _createVNode("li", null, [
                                                  _createVNode(_component_el_checkbox, {
                                                    modelValue: _ctx.report_settings.content.is_have_old,
                                                    "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => (_ctx.report_settings.content.is_have_old = $event))
                                                  }, null, 8, ["modelValue"]),
                                                  _hoisted_147
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_card, {
                                        shadow: "never",
                                        class: "reportNotification"
                                      }, {
                                        default: _withId(() => [
                                          _createVNode("h6", null, [
                                            _hoisted_148,
                                            _hoisted_149,
                                            _createVNode(_component_el_tooltip, {
                                              effect: "dark",
                                              content: "报告通知同时会告知项目管理员",
                                              placement: "top"
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_150
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _createVNode(_component_el_form, { style: {"margin-bottom":"35px"} }, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_form_item, { label: "是否发送邮件报告" }, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_checkbox, {
                                                    modelValue: _ctx.report_settings.notify.email.enable,
                                                    "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => (_ctx.report_settings.notify.email.enable = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_el_form_item, { label: "邮件报告收件人" }, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                                    content: _withId(() => [
                                                      _hoisted_151,
                                                      _hoisted_152,
                                                      _hoisted_153,
                                                      _hoisted_154,
                                                      _hoisted_155,
                                                      _hoisted_156,
                                                      _hoisted_157
                                                    ]),
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_input, {
                                                        modelValue: 
                                  _ctx.report_settings.notify.email.receiver_str
                                ,
                                                        "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => (
                                  _ctx.report_settings.notify.email.receiver_str
                                 = $event)),
                                                        sizi: "mini"
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_form, null, {
                                            default: _withId(() => [
                                              _createVNode(_component_el_form_item, { label: "是否发送企业微信通知" }, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_checkbox, {
                                                    modelValue: _ctx.report_settings.notify.wecom.enable,
                                                    "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => (_ctx.report_settings.notify.wecom.enable = $event))
                                                  }, null, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_el_form_item, { label: "企业微信收件人" }, {
                                                default: _withId(() => [
                                                  _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                                    content: _withId(() => [
                                                      _hoisted_158,
                                                      _hoisted_159,
                                                      _hoisted_160,
                                                      _hoisted_161,
                                                      _hoisted_162,
                                                      _hoisted_163,
                                                      _hoisted_164
                                                    ]),
                                                    default: _withId(() => [
                                                      _createVNode(_component_el_input, {
                                                        modelValue: 
                                  _ctx.report_settings.notify.wecom.receiver_str
                                ,
                                                        "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => (
                                  _ctx.report_settings.notify.wecom.receiver_str
                                 = $event)),
                                                        sizi: "mini"
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode("div", _hoisted_165, [
                        (_ctx.handleFormConfirm === '创建')
                          ? (_openBlock(), _createBlock("div", _hoisted_166, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                size: "mini",
                                style: {"width":"90px"},
                                onClick: _cache[101] || (_cache[101] = ($event: any) => (_ctx.reset(_ctx.ruleForm)))
                              }, {
                                default: _withId(() => [
                                  _hoisted_167
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                size: "mini",
                                style: {"width":"90px"},
                                onClick: _cache[102] || (_cache[102] = ($event: any) => (_ctx.submitForm('ruleForm', _ctx.ruleForm)))
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(_ctx.handleFormConfirm), 1)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.handleFormConfirm !== '创建')
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              type: "primary",
                              size: "mini",
                              style: {"width":"90px"},
                              onClick: _cache[103] || (_cache[103] = ($event: any) => (_ctx.submitForm('ruleForm', _ctx.ruleForm)))
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.handleFormConfirm), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["model", "rules"]), [
                    [_directive_loading, _ctx.task_form_loading]
                  ])
                ]),
                _: 1
              }, 8, ["title", "modelValue"]),
              _createVNode(_component_el_footer, { class: "footerStyle" }, {
                default: _withId(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    size: "mini"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, {
                        label: "每页",
                        style: {"margin-bottom":"0"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.record,
                            "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => (_ctx.record = $event)),
                            style: {"width":"50px"},
                            onChange: _cache[107] || (_cache[107] = ($event: any) => (_ctx.onSearch('paging')))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        style: {"margin-bottom":"0"},
                        label: "条记录"
                      }),
                      _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                        default: _withId(() => [
                          _createVNode(_component_el_pagination, {
                            currentPage: _ctx.currentPage1,
                            "onUpdate:currentPage": _cache[108] || (_cache[108] = ($event: any) => (_ctx.currentPage1 = $event)),
                            "page-size": _ctx.record,
                            layout: "total, prev, pager, next, jumper",
                            total: _ctx.getVisitStatistics.count,
                            onCurrentChange: _cache[109] || (_cache[109] = ($event: any) => (_ctx.onSearch('paging')))
                          }, null, 8, ["currentPage", "page-size", "total"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_dialog, {
            width: "22%",
            modelValue: _ctx.dialogFormVisible1,
            "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => (_ctx.dialogFormVisible1 = $event)),
            title: "自定义配置"
          }, {
            footer: _withId(() => [
              _createVNode("span", _hoisted_168, [
                _createVNode(_component_el_button, {
                  onClick: _cache[111] || (_cache[111] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                }, {
                  default: _withId(() => [
                    _hoisted_169
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[112] || (_cache[112] = ($event: any) => (_ctx.closeBtn(_ctx.ruleForm)))
                }, {
                  default: _withId(() => [
                    _hoisted_170
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withId(() => [
              _createVNode(_component_el_input, {
                rows: 28,
                autocomplete: "off",
                modelValue: _ctx.custom_json,
                "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => (_ctx.custom_json = $event)),
                type: "textarea"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_dialog, {
            width: "22%",
            modelValue: _ctx.dialogFormVisible2,
            "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => (_ctx.dialogFormVisible2 = $event)),
            title: "自定义配置"
          }, {
            footer: _withId(() => [
              _createVNode("span", _hoisted_171, [
                _createVNode(_component_el_button, {
                  onClick: _cache[115] || (_cache[115] = ($event: any) => (_ctx.dialogFormVisible2 = false))
                }, {
                  default: _withId(() => [
                    _hoisted_172
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[116] || (_cache[116] = ($event: any) => (_ctx.dialogFormVisible2 = false))
                }, {
                  default: _withId(() => [
                    _hoisted_173
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withId(() => [
              _createVNode(_component_el_input, {
                rows: 28,
                autocomplete: "off",
                modelValue: _ctx.ruleForm.custom,
                "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => (_ctx.ruleForm.custom = $event)),
                type: "textarea"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})